import React from 'react'
import { View, StyleSheet } from 'react-native'
import PropTypes from 'prop-types'

type QuestionRadioButtonProps = {
  /** The primary color of the radio button. */
  accentColor: string,
  /** Controls if the radio button is selected or not. */
  active?: boolean,
}

/**
 * The button to select a questions answer.
 * @component
 */
export const QuestionRadioButton = ({accentColor, active}: QuestionRadioButtonProps) => {
  const styles = StyleSheet.create({
    container: {
      width: 30,
      height: 30,
      borderRadius: 30,
      borderColor: '#ddd',
      borderWidth: 2,
      margin: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }, 
    inner: {
      width: 20,
      height: 20,
      borderRadius: 20,
      backgroundColor: accentColor ?? 'dodgerblue',
    }
  })
  return (
    <View style={styles.container}>
      {
        active &&
        <View style={styles.inner}>
        </View>
      }    
    </View>
  )
}

QuestionRadioButton.propTypes = {
  accentColor: PropTypes.string,
  active: PropTypes.bool,
}
